<template>
  <div class="contents">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb-main user-member justify-content-sm-between">
            <div class="d-flex align-items-center">
              <h4 class="text-capitalize fw-500 breadcrumb-title">
                <i class="fas fa-store"></i> Online Shop (Eshop)
              </h4>
            </div>
            <div class="text-muted">
              Total: <strong>{{ total }}</strong> toko
            </div>
          </div>
        </div>
      </div>

      <div class="card p-3 mb-3">
        <div class="row align-items-center">
          <div class="col-md-10">
            <input
              v-model="filter.search"
              @keyup.enter="loadList"
              class="form-control form-control-sm"
              placeholder="Cari nama toko, slug, atau email pemilik..."
            >
          </div>
          <div class="col-md-2">
            <button @click="loadList" class="btn btn-primary btn-sm btn-block">
              <i class="fas fa-search"></i> Cari
            </button>
          </div>
        </div>
      </div>

      <div class="card p-0 border bg-white radius-xl">
        <div v-if="loading" class="text-center p-5"><div class="spinner-border"></div></div>
        <div v-else-if="shops.length === 0" class="text-center text-muted p-5">
          <i class="fas fa-store-slash fa-3x mb-3" style="color:#d1d5db;"></i>
          <h5>Tidak ada toko ditemukan</h5>
        </div>
        <div v-else class="table-responsive">
          <table class="table table-hover mb-0">
            <thead style="background:#f9fafb;">
              <tr>
                <th>Toko</th>
                <th>Pemilik</th>
                <th>Paket StarSender</th>
                <th>Orders</th>
                <th>Revenue</th>
                <th>Pending</th>
                <th>Order Terakhir</th>
                <th>Dibuat</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in shops" :key="s.id">
                <td>
                  <div><strong>{{ s.name }}</strong></div>
                  <small class="text-muted">/{{ s.slug }}</small>
                  <span v-if="s.status" class="badge badge-light ml-1">{{ s.status }}</span>
                </td>
                <td>
                  <div>{{ s.owner_name || '-' }}</div>
                  <small class="text-muted">{{ s.owner_email || '-' }}</small>
                </td>
                <td>{{ s.package_name || '-' }}</td>
                <td>
                  <div><strong>{{ s.total_orders }}</strong> total</div>
                  <small class="text-success">{{ s.paid_orders }} paid</small>
                </td>
                <td>{{ formatRupiah(s.total_revenue) }}</td>
                <td>
                  <span v-if="s.pending_count > 0" class="badge badge-warning">{{ s.pending_count }}</span>
                  <span v-else class="text-muted">0</span>
                </td>
                <td><small>{{ formatDate(s.last_order_date) }}</small></td>
                <td><small>{{ formatDate(s.created_at) }}</small></td>
                <td>
                  <a :href="shopPublicUrl(s.slug)" target="_blank" class="btn btn-sm btn-light" title="Buka toko publik">
                    <i class="fas fa-external-link-alt"></i>
                  </a>
                  <button
                    v-if="s.owner_id"
                    class="btn btn-sm btn-success ml-1"
                    title="Login sebagai pemilik"
                    @click="loginAsOwner(s.owner_id)"
                  >
                    <i class="fas fa-sign-in-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="totalPages > 1" class="d-flex justify-content-between align-items-center mt-3">
        <small class="text-muted">Halaman {{ page }} / {{ totalPages }}</small>
        <div>
          <button class="btn btn-sm btn-light" :disabled="page <= 1" @click="goPage(page - 1)">
            <i class="fas fa-chevron-left"></i> Prev
          </button>
          <button class="btn btn-sm btn-light ml-2" :disabled="page >= totalPages" @click="goPage(page + 1)">
            Next <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      loading: false,
      shops: [],
      total: 0,
      page: 1,
      limit: 25,
      totalPages: 1,
      filter: { search: '' },
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    async loadList() {
      this.loading = true;
      try {
        const params = { page: this.page, limit: this.limit };
        if (this.filter.search) params.q = this.filter.search;
        const r = await this.$store.dispatch('admin_online_shops_list', params);
        const data = r.data.data || {};
        this.shops = data.shops || [];
        this.total = data.total || 0;
        this.totalPages = data.total_pages || 1;
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal memuat data toko');
      }
      this.loading = false;
    },
    goPage(p) {
      if (p < 1 || p > this.totalPages) return;
      this.page = p;
      this.loadList();
    },
    shopPublicUrl(slug) {
      return `${window.location.origin}/toko/${slug}`;
    },
    async loginAsOwner(id) {
      try {
        await this.$store.dispatch('auth_login_admin', { id });
        await this.$root.$emit('login', true);
        await this.$router.push('/dashboard');
        window.location.reload();
      } catch (err) {
        this.$toast.error(err.response?.data?.message || 'Gagal login');
      }
    },
    formatRupiah(v) {
      return 'Rp ' + (v || 0).toLocaleString('id-ID');
    },
    formatDate(t) {
      if (!t) return '-';
      return moment(parseInt(t)).format('DD MMM YYYY HH:mm');
    },
  },
};
</script>
